import React from 'react';
import styled from 'styled-components';
import { Captions } from 'components/Typography';
import { Accordion, AccordionDetails } from '@material-ui/core';
import { SmallSectionHeader } from 'components/Typography';
import breakpoints from 'utils/breakpoints';

export const FirstAccordion = styled(({ color, ...otherProps }) => (
  <Accordion {...otherProps} />
))`
  background-image: url(${(props: { image?: string; height?: string }) =>
    props.image});
  background-repeat: no-repeat;
  border-radius: 10px !important;
`;
export const StyledCaption = styled(Captions)`
  && {
    color: #ffffff;
    font-size: 15px !important;
    line-height: 17px !important;
    margin: 0;
  }
`;

export const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    color: #ffffff;
    font-size: 20px !important;
    line-height: 25px !important;
    margin: 0;
  }
`;
export const StyledAccordionDetails = styled(AccordionDetails)`
  && {
    background-color: #ffffff;
    padding: 8px 24px 16px;
    border-left: none;
    @media (max-width: ${breakpoints.xs}) {
      padding: 8px 16px 16px;
    }
  }
`;
